import { typedFetch } from "@/lib/helpers";
import { API_METHODS } from "../shared";
import { BOOKINGS_URL } from "./api-url.constants";
import { UpdateBookingApiDto } from "./dtos";

export const updateBooking = async (booking: UpdateBookingApiDto): Promise<void> => {
  const { _id, ...body } = booking;

  await typedFetch(`${BOOKINGS_URL}/${_id}`, {
    method: API_METHODS.PUT,
    body: JSON.stringify(body),
  });
};
